import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props, data) {
  let submit = useDataSubmit({
    context: 'lead',
    viewPath: props.viewPath,
  })

  let lead_id = useDataValue({
    context: 'lead',
    path: 'id',
    viewPath: props.viewPath,
  })

  return async function onClick(value) {
    await submit({ type: 'set-location', lead_id, location_id: value })
  }
}
